import { ITwoFAServiceGenerateJWTPostData } from 'app/pages/frames/lib/3DS/interface';
import { ParamsGetJWTCreateData } from 'common/interface';

export const getCardinalInitialData = (
  affiliation: any,
  amount: any,
  customerInfo: any,
  referenceId: any,
  submittedFormCardValues: any,
  liveMode?: boolean,
  serviceMerchantName: string = 'Conekta',
) => {
  const { cardExpMonth, cardExpYear, cardNumber, cardholderName } = submittedFormCardValues;
  const { email } = customerInfo;
  const phoneNumber: string = submittedFormCardValues?.shipping?.phone ?? '';
  const year: string = new Date().getFullYear().toString();

  const AdditionalParameters = {
    serviceMcc: '5045',
    serviceAcquirerBin: '451899',
    serviceLoginID: affiliation,
    serviceCountryCode: 'MX',
    serviceMerchantName,
    serviceMerchantID: affiliation,
    serviceMerchantURL: 'https://conekta.com/',
    serviceRequestorID: `10052155*${affiliation}`,
    serviceRequestorName: 'Conekta',
    serviceMobilePhone: '5569654638',
    serviceProductCode: 'SVC',
    overridePaymentMethod: 'CR',
  };

  const cardModel = {
    cardAccountNumber: cardNumber,
    cardExpirationMonth: cardExpMonth,
    cardExpirationYear: `${year.substring(0, 2)}${cardExpYear}`,
    currency: 'MXN',
  };

  const cardToValidate = {
    payerAuthValidateServiceRun: 'true',
    merchantReferenceCode: referenceId,
    unitPrice: amount,
    cardModel: cardModel,
    authenticationTransactionID: 0,
    additionalParameterModel: AdditionalParameters,
    ...(liveMode !== undefined && { liveMode }),
  };

  const transactionData = {
    merchantReferenceCode: referenceId,
    enrollServiceRun: 'true',
    referenceID: referenceId,
    cardModel: cardModel,
    price: amount,
    giftCategory: 'false',
    firstName: cardholderName,
    lastName: '',
    street: 'Av. Nuevo León 404, Hipódromo, Cuauhtémoc',
    city: 'CDMX',
    postalCode: '06100',
    state: '',
    country: 'MX',
    email: email,
    phoneNumber: phoneNumber,
    additionalParameterModel: AdditionalParameters,
    ...(liveMode !== undefined && { liveMode }),
  };

  return {
    cardToValidate: cardToValidate,
    transactionData: transactionData,
  };
};

export const getJWTCreateData = ({
  amount,
  id,
  name,
  customerName,
  liveMode,
}: ParamsGetJWTCreateData): ITwoFAServiceGenerateJWTPostData => {
  const threeDsReferenceID: string = id;
  return {
    orderDetails: {
      Amount: amount.toString() ?? '0',
      CurrencyCode: 'MX',
      NameOnAccount: customerName,
      OrderChannel: '',
      OrderDescription: name,
      OrderNumber: threeDsReferenceID,
    },
    referenceID: threeDsReferenceID,
    ...(liveMode !== undefined && { liveMode }),
  };
};
